// Implements: F-IDN-027
/**
 * A person's organization role as a select (v3 `vPeople`). The caller's own row is disabled with
 * the reason as its tooltip: nobody changes their own role (the server refuses it too, C6).
 */

import type { ReactElement } from "react";

import { useTranslation } from "../../../shared/i18n";
import { Select } from "../../../shared/ui/atoms/Select";
import type { OrgRole } from "../../../types/organization";
import { ORG_ROLES, asRole, roleLabelKey } from "../model/roles";

export interface RoleSelectProps {
  readonly id: string;
  readonly personName: string;
  readonly value: OrgRole;
  readonly own: boolean;
  readonly disabled?: boolean | undefined;
  readonly onChange: (role: OrgRole) => void;
}

export function RoleSelect({ id, personName, value, own, disabled = false, onChange }: RoleSelectProps): ReactElement {
  const { t } = useTranslation();
  const select = (
    <Select
      id={id}
      value={value}
      label={t("organization.people.roleOf", { name: personName })}
      disabled={own || disabled}
      options={ORG_ROLES.map((role) => ({ value: role, label: t(roleLabelKey(role)) }))}
      onChange={(raw) => {
        const role = asRole(raw, ORG_ROLES);
        if (role !== null && role !== value) onChange(role);
      }}
    />
  );
  return own ? <span title={t("organization.people.ownRole")}>{select}</span> : select;
}
